export default __webpack_public_path__ + "static/media/TwiterX-ic.2f10bdb1.svg";